// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postApplyAudioSchemaToDevice } from '../../services/AudioSchemaService';
import { ApplyAudioSchemaToDeviceRequest, AudioSchemaPerDevice } from '../../types/AudioSchemas';

type Result = UseMutationResult<AudioSchemaPerDevice, Error, ApplyAudioSchemaToDeviceRequest>;

function usePostApplyAudioSchemaToDevice(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postApplyAudioSchemaToDevice, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostApplyAudioSchemaToDevice;
